import { render, staticRenderFns } from "./CBlock.vue?vue&type=template&id=1d6be853&scoped=true&"
import script from "./CBlock.vue?vue&type=script&lang=ts&"
export * from "./CBlock.vue?vue&type=script&lang=ts&"
import style0 from "./CBlock.vue?vue&type=style&index=0&id=1d6be853&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6be853",
  null
  
)

export default component.exports